export default __webpack_public_path__ + "static/media/papaya.b97679d2.png";